<template lang="html">
  <input
    :type="fieldType"
    :min="min"
    class="form-control text-field"
    :placeholder="placeholder"
    v-bind:value="value"
    v-on:input="$emit('input', $event.target.value)"
    required
  />
</template>

<script>
export default {
  name: "text-field",
  data: function() {
    return {
      placeholder: String,
      fieldType: String,
      min: String
    };
  },
  props: {
    value: {
      type: [String, Number]
    }
  }
};
</script>

<style lang="css" scoped>
.text-field {
  border-radius: 25px;
  color: var(--v-content-base);
  border: var(--v-content-base) 2px solid;
  padding-left: 2.5vh !important;
  padding-right: 2.5vh !important;
  min-height: 6vh;
  width: 100%;
  outline: none;
}
</style>
